import { c as _c } from "react/compiler-runtime";
import * as React from "react";
export function InputForm(t0) {
  const $ = _c(19);
  const {
    text,
    onTextChange
  } = t0;
  const formRef = React.useRef(null);
  const previousToValueRef = React.useRef(undefined);
  const toInputRef = React.useRef(null);
  let t1;
  if ($[0] !== onTextChange) {
    t1 = function handleInputChange(t2) {
      const {
        currentTarget: t3
      } = t2;
      const {
        value
      } = t3;
      previousToValueRef.current = value;
      onTextChange?.(value);
    };
    $[0] = onTextChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleInputChange = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const input = toInputRef.current;
      if (input) {
        input.focus({
          preventScroll: true
        });
        input.setSelectionRange(0, input.value.length);
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const focusAndSelectAll = t2;
  let t3;
  let t4;
  if ($[3] !== text) {
    t3 = () => {
      if (previousToValueRef.current !== text) {
        focusAndSelectAll();
      }
      if (typeof previousToValueRef.current === "string" && formRef.current) {
        formRef.current.scrollIntoView({
          block: "nearest",
          inline: "nearest",
          behavior: "smooth"
        });
      }
      previousToValueRef.current = text;
    };
    t4 = [focusAndSelectAll, text, previousToValueRef, formRef];
    $[3] = text;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  React.useEffect(t3, t4);
  const [from, setFrom] = React.useState("noscript");
  const fromInputRef = React.useRef(null);
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setFrom("bookmark");
    };
    t6 = [];
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  React.useEffect(t5, t6);
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = function handleFormSubmit() {
      if (fromInputRef.current) {
        fromInputRef.current.value = "web";
      }
      return true;
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const handleFormSubmit = t7;
  let t8;
  if ($[9] !== from) {
    t8 = <input ref={fromInputRef} type="hidden" name="from" value={from} />;
    $[9] = from;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <label htmlFor="to" className="pointer-events-none absolute top-[21px] left-0 inline-block pt-[0.3em] pl-[0.7em] font-field">njt</label>;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== handleInputChange || $[13] !== text) {
    t10 = <input ref={toInputRef} id="to" name="to" placeholder="<package> [destination]" value={text} onFocus={focusAndSelectAll} onChange={handleInputChange} className="inline-block w-full max-w-full appearance-none rounded-[5px] border border-input bg-muted py-[0.3em] pr-[4em] pl-[3em] font-field placeholder:text-muted-foreground focus:border-primary focus:shadow-[0_0_10px_var(--color-ring)] focus:outline-none" />;
    $[12] = handleInputChange;
    $[13] = text;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <button type="submit" tabIndex={-1} className="absolute top-[21px] right-0 cursor-pointer pt-[0.25em] pr-[0.4em] pb-[0.3em] pl-0 focus:outline-none active:top-[22px]">🐸 →</button>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t8) {
    t12 = <form ref={formRef} action="/jump" onSubmitCapture={handleFormSubmit} className="relative block w-full max-w-full pt-5 text-[2em] leading-[1em] whitespace-nowrap max-[600px]:text-[1.8em] max-[550px]:text-[1.6em] max-[510px]:text-[1.5em] max-[450px]:text-[1.4em] max-[420px]:text-[1.3em] max-[400px]:text-[1.25em] max-[370px]:text-[1.1em] max-[350px]:text-[1em]">{t8}{t9}{t10}{t11}</form>;
    $[16] = t10;
    $[17] = t8;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
}